import React from 'react'
import { Caret } from "@routes/IconeSvg";
import { useNotification } from '@hooks/useNotification';
export default function LockCollapse(
    {
        t,
        label,
        placeholder
    }
){
    const {showWarning} = useNotification()
    const onClickOpen= ()=> showWarning("Accès limité Veuillez demander l'accès à votre administrateur")
    return(
        <div className="arh-relative arh-w-full" onClick={onClickOpen}>
            <label className='arh-mb-1 arh-font-poppins arh-text-xs arh-font-medium arh-text-darkColor'>
                    {t(label)}
            </label>
            <div className='arh-relative arh-h-11 arh-w-full arh-rounded arh-border arh-border-solid arh-pointer-events-none arh-cursor-none arh-border-greyDisabledBorder arh-bg-greyDisabled arh-text-greyDisabledText arh-py-3 arh-pl-6 arh-pr-[92px] arh-text-left arh-font-poppins arh-text-xs arh-font-normal placeholder:arh-text-[#8B8F91] focus:arh-outline-none focus-visible:arh-border-[#ECECEC] focus-visible:arh-ring-2 focus-visible:arh-ring-[#ECECEC] focus-visible:arh-ring-opacity-75 focus-visible:arh-ring-offset-2 focus-visible:arh-ring-offset-greyColor'>
            <input
              className="arh-bg-transparent arh-ml-2 arh-block arh-w-full arh-max-w-full arh-truncate arh-text-ellipsis arh-border-0 arh-text-greyDisabledText placeholder:arh-text-greyDisabledText arh-pointer-events-none"
              type="text"
              placeholder={placeholder}
            />
            <span className="arh-pointer-events-none arh-absolute arh-inset-y-0 arh-right-0 arh-flex arh-items-center arh-pr-18">
              <Caret
                className="arh-rotate-0"
                aria-hidden="true"
              />
            </span>
            </div>
        </div>
    )
}